/**
 * Provider for `browserId`
 * @module
 */

/**
 * @type {DataProvider}
 */
module.exports = {
  provides: 'browserId',
  shouldTrack: true,
  isSticky: true,

  getter: [
    'sources/browser_id',
    /**
     * @return {string}
     */
    function(BrowserIdSource) {
      return BrowserIdSource.getId();
    },
  ],
};
